module.exports = __webpack_public_path__ + "img/icon_charge_title.f126a76f.png";